<template>
  <div ref="portal" class="body-portal">
    <slot />
  </div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from "vue";

/**
 * Vue 2 has no Teleport — move this wrapper's content to `<body>` on mount so a
 * `position: fixed` overlay is not offset/clipped by a transformed ancestor.
 *
 * The Vuetify `v-navigation-drawer` applies `transform: translateX(...)`, which
 * makes any `position: fixed` descendant position against the drawer instead of
 * the viewport — that is why a modal rendered inside a drawer sits over the
 * drawer rather than centred on the screen.
 */
const portal = ref(null);

onMounted(() => {
  if (portal.value && portal.value.parentNode !== document.body) {
    document.body.appendChild(portal.value);
  }
});

onBeforeUnmount(() => {
  if (portal.value && portal.value.parentNode) {
    portal.value.parentNode.removeChild(portal.value);
  }
});
</script>

<style scoped>
.body-portal {
  display: contents;
}
</style>
